import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { WidgetWrapper } from '../../layout';
import { jsx as _jsx } from "react/jsx-runtime";
export const Error = ({
  children
}) => /*#__PURE__*/_jsx(WidgetWrapper, {
  children: /*#__PURE__*/_jsx(UIErrorMessage, {
    type: "badRequest",
    children: /*#__PURE__*/_jsx("p", {
      children: children || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "common.error"
      })
    })
  })
});